<div>
<share-buttons
  [theme]="'circles-dark'"
  [include]="['copy', 'facebook', 'email', 'messenger', 'linkedin', 'twitter', 'whatsapp']"
  [showText]="true"
  [showIcon]="true"
  [url]="urlCopiar"
  description="Ecosistema Cultural, Artístico y Patrimonial"
  twitterAccount="rohiriw"
  >
</share-buttons>
</div>
